import _ from 'underscore';
import { MmcDataSource } from '../index';
import { configs } from '../configs';
import { memoizeWithAllArgsHashed as memoize } from '../utils';
import { isLocal } from './mocks/mock-mmc-data-sources';
import { mockStoreQueries } from './mocks/mock-store-queries';

let p$Store = {};
let p$StoresList = {};
const entities = {
  getStoreEntity: memoize(storeId =>
    new MmcDataSource({
      entityName: 'Stores',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.stores,
      idAttribute: storeId,
    })),
  getStoreWithGmcCreds: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.storesWithGmcCreds,
      idAttribute: storeId,
    })),
  getUpgradePlaceholderStoreWithGmcStore: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.upgradePlaceholderStoreWithGmcStore,
      idAttribute: storeId,
    })),
  getProductIssueDetails: memoize((storeId, issueCode) =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getProductIssueDetails(storeId, issueCode),
      idAttribute: storeId,
    })),
  getIssuesCount: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getIssuesCount(storeId),
      idAttribute: storeId,
    })),
  getProviderBootstrapData: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getProviderBootstrapData(storeId),
      idAttribute: storeId,
    })),
  getNewProviderBootstrapData: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getNewProviderBootstrapData(storeId),
      idAttribute: storeId,
    })),
  getProductOverviewChart: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getProductOverviewChart(storeId),
      idAttribute: storeId,
    })),
  getProductRejectionChart: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getProductRejectionChart(storeId),
      idAttribute: storeId,
    })),
  getProductPerformanceChart: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getProductPerformanceChart(storeId),
      idAttribute: storeId,
    })),
  getStoreStatus: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getStoreStatus(storeId),
    })),
  getStorePilotFeatures: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getStorePilotFeatures(storeId),
    })),
  getCustomerFraudStatus: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getCustomerFraudStatus(storeId),
    })),
  getStoreIssues: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getStoreIssues(storeId),
      idAttribute: storeId,
    })),
  getFeedIssues: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getFeedIssues(storeId),
      idAttribute: storeId,
    })),
  getProductIssues: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getProductIssues(storeId),
      idAttribute: storeId,
    })),
  getProductIssuesReportStatus: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getProductIssuesReportStatus(storeId),
      idAttribute: storeId,
    })),
  getEvRejectionDistributionByFlagAreaIds: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getEvRejectionDistributionByFlagAreaIds(storeId),
      idAttribute: storeId,
    })),
  getEvRejectionDistributionByFlagAreaIdsPageByPage: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getEvRejectionDistributionByFlagAreaIdsPageByPage(storeId),
      idAttribute: storeId,
    })),
  getRejectedOffersForFlagAreaId: memoize((storeId, flagAreaIdCode) =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getRejectedOffersForFlagAreaId(storeId, flagAreaIdCode),
      idAttribute: storeId,
    })),
  getRejectedOffersForFlagAreaIdPageByPage: memoize((storeId, flagAreaIdCode) =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getRejectedOffersForFlagAreaIdPageByPage(storeId, flagAreaIdCode),
      idAttribute: storeId,
    })),
  runProductIssuesReport: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.runProductIssuesReport(storeId),
      idAttribute: storeId,
    })),
  downloadProductIssuesReport: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.downloadProductIssuesReport(storeId),
      idAttribute: storeId,
    })),
  downloadStoreIssuesReport: memoize((storeId, issueCode, reportKey, market) =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.downloadStoreIssuesReport(storeId, issueCode, reportKey, market),
      idAttribute: storeId,
    })),
  isProductListingsPerformanceUXEnabled: memoize(storeId =>
    new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.isProductListingsPerformanceUXEnabled(storeId),
      idAttribute: storeId,
    })),
};

export const storeQueries = {
  gridDataSource(queryParams = {}) {
    const entity = entities.getStoreEntity();
    return {
      type: 'jsdata',
      entity,
      primaryKey: 'Id',
      query: queryParams,
    };
  },
  hasPlaceholderStores() {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.hasPlaceholderStore,
      idAttribute: null,
    });
    return entity.find();
  },
  getPlaceholderStoresGrid() {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getPlaceholderStores,
      idAttribute: null,
    });

    return {
      type: 'jsdata',
      entity,
      primaryKey: 'Id',
      query: {},
    };
  },
  upgradePlaceholderStore(data) {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.upgradePlaceholdrStore,
      idAttribute: null,
    });
    return entity.create(data);
  },
  upgradePlaceholderToNewStore(data) {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.createStoreForPlaceholderStore,
      idAttribute: null,
    });
    p$Store = {};
    p$StoresList = {};
    return entity.create(data);
  },
  getStores({
    page = 1,
    pageSize = 20,
    withCache = false,
  } = {}) {
    const cacheKey = `${page}-${pageSize}`;
    if (withCache && p$StoresList[cacheKey]) {
      return p$StoresList[cacheKey];
    }
    const entity = entities.getStoreEntity();

    const params = {
      query: {
        $top: pageSize,
        $skip: page < 1 ? 0 : pageSize * (page - 1),
      },
    };

    const stores = entity.findAll(params);

    p$StoresList = {}; // store only one list
    p$StoresList = {};
    if (withCache) {
      p$StoresList[cacheKey] = stores;
    }

    return stores;
  },
  getStoresForMainMenu() {
    return this.getStores({
      page: 0,
      pageSize: 30,
      withCache: true,
    });
  },
  getStore(storeId, withCache = false) {
    if (withCache && p$Store[storeId]) {
      return p$Store[storeId];
    }

    const entity = entities.getStoreEntity(storeId);
    const store = entity.find(storeId);

    p$Store = {}; // store only one
    if (withCache) {
      p$Store[storeId] = store;
    }
    return store;
  },
  getDomains() {
    const entityName = 'GetDomains';

    const entity = new MmcDataSource({
      entityName,
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getDomains,
    });

    const params = {
      query: {},
    };

    return entity.findAll(params);
  },
  getGmcStores({
    authCode,
    page = 1,
    pageSize = 20,
    orderBy = undefined,
    searchText = undefined,
  }) {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getGmcStores,
    });

    const params = {
      key: `'${authCode}'`,
      $top: pageSize,
      $skip: page < 1 ? 0 : pageSize * (page - 1),
    };

    if (orderBy) {
      params.$orderby = orderBy;
    }

    if (searchText) {
      params.$filter = `contains(tolower(GoogleMerchantId), tolower('${searchText}')) or contains(tolower(StoreName), tolower('${searchText}'))`;
    }

    return entity.get(null, { query: params }, false);
  },
  validateCreateParams(data) {
    const entityName = 'ValidateCreateParams';

    const entity = new MmcDataSource({
      entityName,
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.validateCreateParams,
    });

    return entity.create(data);
  },
  createStore(data) {
    const entity = entities.getStoreEntity(data.Id);
    p$Store = {};
    p$StoresList = {};
    return entity.create(data);
  },
  createStoreWithGmcCreds(data) {
    const entity = entities.getStoreWithGmcCreds(data.Id);
    p$Store = {};
    p$StoresList = {};
    return entity.create(data);
  },
  upgradePlaceholderStoreWithGmcStore(data) {
    const entity = entities.getUpgradePlaceholderStoreWithGmcStore(data.Id);
    p$Store = {};
    p$StoresList = {};
    return entity.create(data);
  },
  updateStore(data) {
    const entity = entities.getStoreEntity(data.Id);
    p$Store = {};
    p$StoresList = {};
    return entity.update(data.Id, data);
  },
  deleteStore(storeId) {
    const entity = entities.getStoreEntity(storeId);
    p$Store = {};
    p$StoresList = {};
    return entity.delete(storeId);
  },
  getProductIssueDetails(storeId, issueCode) {
    const entity = entities.getProductIssueDetails(storeId, issueCode);

    return {
      type: 'jsdata',
      entity,
      primaryKey: 'Id',
      query: {},
    };
  },
  getIssuesCount(storeId) {
    const entity = entities.getIssuesCount(storeId);

    return entity.find();
  },
  getProviderBootstrapData(storeId) {
    const entity = entities.getProviderBootstrapData(storeId);

    return entity.find();
  },
  getNewProviderBootstrapData(storeId) {
    const entity = entities.getNewProviderBootstrapData(storeId);

    return entity.find();
  },
  getProductOverviewChart(storeId) {
    const entity = entities.getProductOverviewChart(storeId);

    return entity.find();
  },
  getProductPerformanceChart(storeId) {
    const entity = entities.getProductPerformanceChart(storeId);

    return entity.find();
  },
  getProductRejectionChart(storeId) {
    const entity = entities.getEvRejectionDistributionByFlagAreaIds(storeId);

    return entity.find();
  },
  getStoreStatus(storeId) {
    const entity = entities.getStoreStatus(storeId);
    const result = entity.find();
    return result;
  },
  getCustomerFraudStatus(storeId) {
    const entity = entities.getCustomerFraudStatus(storeId);
    const result = entity.find();
    return result;
  },
  startStoreAppeal(storeId, data) {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.startStoreAppeal(storeId),
    });
    const result = entity.create(data);
    return result;
  },
  getStorePilotFeatures(storeId) {
    const entity = entities.getStorePilotFeatures(storeId);
    const result = entity.find();
    return result;
  },
  getStoreIssues(storeId) {
    const entity = entities.getStoreIssues(storeId);

    return {
      type: 'jsdata',
      entity,
      primaryKey: 'Id',
      query: {},
    };
  },
  getFeedIssues(storeId) {
    const entity = entities.getFeedIssues(storeId);

    return {
      type: 'jsdata',
      entity,
      primaryKey: 'Id',
      query: {},
    };
  },
  getProductIssues(storeId) {
    const entity = entities.getProductIssues(storeId);

    return {
      type: 'jsdata',
      entity,
      primaryKey: 'Id',
      query: {},
    };
  },
  getProductIssuesReportStatus(storeId) {
    const entity = entities.getProductIssuesReportStatus(storeId);

    return entity.find();
  },
  getEvRejectionDistributionByFlagAreaIdsPageByPage(storeId) {
    const entity = entities.getEvRejectionDistributionByFlagAreaIdsPageByPage(storeId);

    return {
      type: 'jsdata',
      entity,
      primaryKey: 'FlagAreaIdCode',
      query: {},
    };
  },
  getRejectedOffersForFlagAreaId(storeId, flagAreaIdCode) {
    const entity = entities.getRejectedOffersForFlagAreaId(storeId, flagAreaIdCode);

    return entity.find();
  },
  getRejectedOffersForFlagAreaIdPageByPage(storeId, flagAreaIdCode) {
    const entity = entities.getRejectedOffersForFlagAreaIdPageByPage(storeId, flagAreaIdCode);

    return {
      type: 'jsdata',
      entity,
      primaryKey: 'ProductId',
      query: {},
      options: {
        afterFindAll: (resources, attrs) => {
          if (!_.isArray(attrs)) {
            return [];
          }
          _.map(attrs, item => _.defaults(item, { FlagAreaIdCode: flagAreaIdCode }));
          return attrs;
        },
      },
    };
  },
  runProductIssuesReport(storeId) {
    const entity = entities.runProductIssuesReport(storeId);

    return entity.find();
  },
  downloadProductIssuesReport(storeId) {
    const entity = entities.downloadProductIssuesReport(storeId);

    return entity.find();
  },
  downloadStoreIssuesReport(storeId, issueCode, reportKey, market) {
    const entity = entities.downloadStoreIssuesReport(storeId, issueCode, reportKey, market);

    return entity.find();
  },
  getProductListingsPerformanceChart(storeId) {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.getProductListingsPerformanceChart(storeId),
      idAttribute: storeId,
    });
    return entity.find();
  },
  isProductListingsPerformanceUXEnabled(storeId) {
    const entity = entities.isProductListingsPerformanceUXEnabled(storeId);

    return entity.find();
  },

  submitAppeal(storeId, data) {
    const entity = new MmcDataSource({
      entityName: '',
      routePrefix: configs.routes.oDataRoute,
      endpoint: configs.endpoints.submitAppeal(storeId),
      idAttribute: storeId,
    });
    return entity.create(data);
  },
};

export const getStoreQueriesWithLocalMock = () => {
  if (isLocal()) {
    return mockStoreQueries;
  }

  return storeQueries;
};
